<lib-pill [variant]="variant">
  <ls-p level="2" class="px-small capitalize">
    {{ applicationOrLicenseStatus | licenseStatus }}
  </ls-p>
</lib-pill>
